<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2" title="项目信息">
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="项目名称">{{ form.technologyProject.projectName }}</a-descriptions-item>
			<a-descriptions-item label="项目总投资(万元)">{{ form.technologyProject.investment }}</a-descriptions-item>
			<a-descriptions-item label="项目开始时间">{{ form.technologyProject.startTimeInterva &&
				form.technologyProject.startTimeInterva.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="项目结束时间">{{ form.technologyProject.endTimeInterva &&
				form.technologyProject.endTimeInterva.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="项目负责人">{{ form.technologyProject.projectLinkman }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.technologyProject.phone }}</a-descriptions-item>
			<a-descriptions-item label="年研发经费(万元)">{{ form.technologyProject.researchGrant }}</a-descriptions-item>
			<a-descriptions-item label="高新领域">
				<dict-render :dict-obj="dictObjs['research_field']" :text="form.technologyProject.researchField"
					v-if="form.technologyProject.researchField"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目阶段">
				<dict-render :dict-obj="dictObjs['projectStage']" :text="form.technologyProject.projectPhase"
					v-if="form.technologyProject.projectPhase"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目分类">
				<dict-render :dict-obj="dictObjs['project_type']" :text="form.technologyProject.projectType"
					v-if="form.technologyProject.projectType"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="行业类型">
				<dict-render :dict-obj="dictObjs['projectType']" :text="form.technologyProject.industry"
					v-if="form.technologyProject.industry"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目概述" :span="2">{{ form.technologyProject.projectView }}</a-descriptions-item>
			<a-descriptions-item label="项目需求" :span="2">{{ form.technologyProject.projectDemand }}</a-descriptions-item>
			<a-descriptions-item label="项目图片" :span="2">
				<img-upload v-model:value="form.technologyProject.picture" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
			<a-descriptions-item label="附件" :span="2">
				<file-upload v-model:value="form.technologyProject.file" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
		</a-descriptions>
		<a-descriptions :column="2" title="评估信息">
			<a-descriptions-item label="评估人/机构名称">{{ form.name }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.phoneNumber }}</a-descriptions-item>
			<a-descriptions-item label="评估内容" :span="2">{{ form.evaluationContent }}</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";
export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: "projectStage,research_field,project_type,projectType",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
